// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"L9-z"};